import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from './Model';

export interface IAutoRecommendationTypeModel extends IModel {
  autoRecommendationTypeId: number;
  name: string;
  isActive: boolean;
  needsValue: boolean;
}

export class AutoRecommendationTypeModel
  extends Model
  implements ModelRecord<IAutoRecommendationTypeModel>
{
  autoRecommendationTypeId: number;
  name: string;
  isActive: boolean;
  needsValue: boolean;

  constructor(params?: Partial<IAutoRecommendationTypeModel>) {
    super(params);
    this.autoRecommendationTypeId = defaultTo(
      params?.autoRecommendationTypeId,
      0,
    );
    this.name = defaultTo(params?.name, '');
    this.isActive = defaultTo(params?.isActive, true);
    this.needsValue = defaultTo(params?.needsValue, false);
  }
}
